module.exports = __webpack_public_path__ + "ffa2eceb172f37b04c04ee0173995191.svg";